module.exports = __webpack_public_path__ + "img/高老庄男.ec24dfd0.png";